import moment from "moment";
import React, { Component } from "react";
import LoadingPage from "../../components/Loading/Loading";
import Table from "../../components/Table/TableCustomer";
import config from "../../config";
import errorFunctions from "../../store/errorFunctions";

import "../common.css";
import "./CustomerList.css";
// import { IoMdAddCircle } from "react-icons/io";
import { MdClose } from "react-icons/md";
import Modal from "react-modal";
import CustomerAdd from "./CustomerAdd/CustomerAdd";

export default class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      customers: [],
      objCustomer: null,
      searchFilter: "",
      pageNumber: 1,
      rowsPerPage: 10,
      order: "asc",
      orderBy: "",
      defaultTab: "Customer",
    };
  }

  componentDidMount() {
    this.retrieveCustomer();
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  retrieveCustomer = ({
    urlTxt,
    rowPerPage,
    pageNumber,
    searchTxt,
    orderTxt,
  } = {}) => {
    this.setState({ loading: true });
    let apiUrl =
      config.backendServer +
        `customers/?brandId=${this.props.selectedbrandID}` || urlTxt;
    if (urlTxt) apiUrl = urlTxt;
    else {
      const pageSize = `&page_size=${
        rowPerPage || this.state.rowsPerPage || ""
      }`;
      const pageNo = `&page=${pageNumber || this.state.pageNumber}`;
      const isSearchEmail = this.validateEmail(searchTxt);
      const encEmail = encodeURI(searchTxt).replace(/\+/g, "%2B");
      const search = isSearchEmail
        ? `&query_email=${encEmail}`
        : `&q=${searchTxt || this.state.search || ""}`;
      const ordering = `&ordering=${orderTxt || this.state.orderingBy || ""}`;

      apiUrl = apiUrl + `${pageSize}${pageNo}${search}${ordering}`;
    }

    this.props
      .protectedFetch(apiUrl, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        //do not show email with @treeclouds.com and @karadigital.co
        let tempCustomers = [];
        if (res.results.length > 0) {
          tempCustomers = res.results.filter(
            (x) =>
              !x.email.includes("@treeclouds.com") &&
              !x.email.includes("@karadigital.co")
          );
        }
        this.setState({ customers: tempCustomers, objCustomer: res, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("fail");
      });
  };

  filterChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  searchChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  onKeyDown = (e) => {
    if (e.key === "Enter")
      this.retrieveCustomer({ searchTxt: this.state.searchFilter });
  };

  handleAddCustomer = () => {
    this.setState({ openCustomerAdd: true });
  };

  render() {
    const isMobile =
      Math.min(window.screen.width, window.screen.height) < 768 ||
      navigator.userAgent.indexOf("Mobi") > -1;

    let customer = this.state.customers;

    // Filter out warranties
    let filterCustomer = customer;

    //RMAS-37 search filter function
    // if (this.state.searchFilter) {
    //   customer.forEach((item) => {
    //     if (
    //       item.first_name?.toLowerCase()?.includes(this.state.searchFilter.trim().toLowerCase()) ||
    //       item.last_name?.toLowerCase()?.includes(this.state.searchFilter.trim().toLowerCase()) ||
    //       item.email?.includes(this.state.searchFilter.trim().toLowerCase())
    //     ) {
    //       filterCustomer.push(item);
    //     }
    //   });
    // } else {
    //   customer.map((val) => filterCustomer.push(val));
    // }

    const tableHead = ["Commercial Admin", "Commercial Staff"].includes(
      this.props.role
    )
      ? [
          {
            id: "first_name",
            label: "First Name",
            filter: "first_name",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "last_name",
            label: "Last Name",
            filter: "last_name",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "email",
            label: "Email",
            filter: "user__email",
            enablefilter: true,
            width: "200px",
            valueDisplay: (value) => value || "email empty",
          },
          {
            id: "mobile",
            label: "Phone Number",
            filter: "mobile",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "country",
            label: "Country",
            filter: "user__country",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
        ]
      : [
          {
            id: "first_name",
            label: "First Name",
            filter: "first_name",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "last_name",
            label: "Last Name",
            filter: "last_name",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "email",
            label: "Email",
            filter: "user__email",
            enablefilter: true,
            width: "200px",
            valueDisplay: (value) => value || "email empty",
          },
          {
            id: "mobile",
            label: "Phone Number",
            filter: "mobile",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "country",
            label: "Country",
            filter: "user__country",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "last_login",
            label: "Last Login",
            filter: "last_login",
            defaultSort: "desc",
            enablefilter: true,
            valueDisplay: (value) =>
              value === null
                ? "Never"
                : moment(value).format("DD-MM-YYYY HH:mm"),
          },
          {
            id: "verificationStatus",
            label: "Status",
            filter: "status",
            enablefilter: true,
            valueDisplay: (value) => value || "",
          },
          {
            id: "action",
            label: "Action",
            filter: "action",
            enablefilter: false,
            valueDisplay: (value) => value || "",
          },
        ];

    return (
      <div>
        {this.state.loading && <LoadingPage />}

        <div className="row">
          <div className="d-flex justify-content-end gap-2 mb-3">
            <div className="input-group col-3 pr-0">
              <input
                type="text"
                placeholder="Search Customer / Email"
                id={"searchFilter"}
                className={"form-control"}
                onChange={this.searchChange}
                onKeyDown={this.onKeyDown}
                value={this.state.searchFilter}
                // width={"100rem"}
              />
              <div className="input-group-prepend">
                <span className="form-control ">
                  <i className="fa fa-search form-control-icon"></i>
                </span>
              </div>
            </div>
            <button
              title="Add Customer"
              className="k-btn k-btn-primary k-btn-sm"
              onClick={this.handleAddCustomer}
            >
              Add New Customer
            </button>
          </div>
          <div className="d-flex justify-content-end"></div>
        </div>

        {customer.length === 0 && <div>No customer</div>}
        {customer.length > 0 && (
          <div className={"admin-table-container card"}>
            <Table
              head={tableHead}
              data={filterCustomer}
              retrieveCustomer={this.retrieveCustomer}
              protectedFetch={this.props.protectedFetch}
              selectedbrandID={this.props.selectedbrandID}
              objCustomer={this.state.objCustomer}
              rowsPerPage={this.state.rowsPerPage}
              rowsPerPageChg={(val) => this.setState({ rowsPerPage: val })}
              pageNumber={this.state.pageNumber}
              onOrderBy={(orderBy_) => this.setState({ orderBy: orderBy_ })}
              orderBy={this.state.orderBy}
              pageNumberChg={(val) => this.setState({ pageNumber: val })}
              order={this.state.order}
              onOrder={(val) =>
                this.setState({
                  order: val,
                })
              }
            />
          </div>
        )}

        <Modal
          isOpen={this.state.openCustomerAdd}
          // onRequestClose={() => this.setState({ openCustomerAdd: false })}
          contentLabel={"Add New Device."}
          // style={customStyles}
          className={isMobile ? "input-modal-mobi" : "input-modal"}
        >
          <button
            onClick={() => this.setState({ openCustomerAdd: false })}
            className={"info-modal-close"}
          >
            <MdClose />
          </button>
          <CustomerAdd
            protectedFetch={this.props.protectedFetch}
            handleCloseModal={() => this.setState({ openCustomerAdd: false })}
            handleRetrieveCustomerList={() => this.retrieveCustomer()}
            selectedBrandId={this.props.selectedbrandID}
            role={this.props.role}
            userInfo={this.props.userInfo}
            isCommercial={this.props.isCommercial}
          />
        </Modal>
      </div>
    );
  }
}
